export default {"src":"/_next/static/media/close-screen.162337ba.svg","height":18,"width":18};